import { EditableText } from "@/components/EditableText";
import { showSuccess, showApiError } from "@/lib/toast";
import { ContentGroup } from "@/lib/types";
import { getContentGroupDetails, updateContentGroup } from "@/sideEffects/api";
import { selectActiveFirm } from "@/store/appSelectors";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";

interface Props {
  contentGroup: ContentGroup;
}

export const UpdateContentGroupNameInput: React.FC<Props> = ({ contentGroup }) => {
  const { t } = useTranslation();
  const activeFirm = useSelector(selectActiveFirm);

  const queryClient = useQueryClient();
  const updateContentGroupMutation = useMutation({
    mutationFn: async (newName: string) => {
      const contentGroupExistingLastStateFromDB = await getContentGroupDetails(
        String(activeFirm?.firmGuid),
        String(contentGroup.contentGroupGuid)
      );
      const contentGroupExistingLastStateFromDBSplitContentGroup =
        contentGroupExistingLastStateFromDB.data as ContentGroup;

      updateContentGroup({
        firmGuid: String(activeFirm?.firmGuid),
        contentGroupGuid: contentGroup.contentGroupGuid,
        name: newName,
        isShuffle: contentGroupExistingLastStateFromDBSplitContentGroup.isShuffle,
        screenSizeId: contentGroupExistingLastStateFromDBSplitContentGroup.screenSizeintId,
        type: contentGroupExistingLastStateFromDBSplitContentGroup.type,
      });
    },

    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["contentGroupDetails"],
      });
      showSuccess(t("common.updatedSuccess"));
    },
    onError: showApiError,
  });

  return (
    <EditableText
      initialText={contentGroup.name || ""}
      onSave={(text) => updateContentGroupMutation.mutate(text)}
      isLoading={updateContentGroupMutation.isPending}
      isFinishedLoading={updateContentGroupMutation.isSuccess}
    />
  );
};
